import { render } from "./moudle5.vue?vue&type=template&id=9f143902&ts=true"
import script from "./moudle5.vue?vue&type=script&lang=ts"
export * from "./moudle5.vue?vue&type=script&lang=ts"

import "./moudle5.vue?vue&type=style&index=0&id=9f143902&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__